type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
};

export const SEARCHCASE_HEADERS: Header[] = [
  { key: "caseId", label: "Case ID", sortable: true },
  { key: "dateOfExam", label: "Date Of Exam", sortable: true },
  { key: "casePriorityDesc", label: "Priority", sortable: true },
  { key: "caseTypeDesc", label: "Case Type", sortable: true },
  { key: "masterClaimNumber", label: "Claim No", sortable: true },
  { key: "locationOfExam", label: "Location Of Exam", sortable: true },
  { key: "qmeDoctorName", label: "Doctor Name", sortable: true },
  { key: "subjectFullName", label: "Patient Full Name", sortable: true },
  { key: "caseStageDesc", label: "Case Stage", sortable: true },
  {
    key: "actions",
    label: "Action",
  },
];

export const GENERAL_LOG_HEADERS: Header[] = [
  { key: "createdByName", label: "Created By" },
  { key: "createdDate", label: "Created On" },
  { key: "modifiedByName", label: "Last Modified By" },
  { key: "modifiedDate", label: "Last Modified On" },
];

export const TEAM_MEMBERS_HEADERS: Header[] = [
  { key: "memberroledesc", label: "Role" },
  { key: "memberfullname", label: "Name" },
  { key: "memberemailid", label: "Email ID" },
  { key: "memberphonenumber", label: "Phone" },
  { key: "memberfaxnumber", label: "Fax #" },
];

export const STAGE_STATUS_LOG_HEADERS: Header[] = [
  { key: "currentStage", label: "Stage" },
  { key: "addedByName", label: "Who" },
  { key: "userRoleName", label: "Role" },
  { key: "addedOn", label: "When" },
  { key: "elapsedTimeDescription", label: "Elapsed Time" },
];

export const CASEBILLINGHEADER: Header[] = [
  { key: "billingFor", label: "User" },
  { key: "billingForUserRole", label: "Role" },
  { key: "rateType", label: "Rate Type" },
  { key: "currency", label: "Currency" },
  { key: "isActive", label: "Status" },
  { key: "lastUpdatedOn", label: "Last Updated On" },
  { key: "modifiedByName", label: "Last Updated By" },
  {
    key: "actions",
    label: "Action",
  },
];
